import { useEffect } from 'react';

export const useHandleKeyDown = ({ isMobile, submitOnKeyPressAllowed, messageInput, onSubmit }) => {
    const handleKeyDown = e => {
        const { keyCode, shiftKey } = e;
        const isEnter = keyCode === 13;
        const eventAllowed = submitOnKeyPressAllowed.current;
        const isNotEmptyValue = messageInput.current && messageInput.current.textarea.value;

        if (isEnter && !shiftKey && eventAllowed && isNotEmptyValue) {
            e.preventDefault();

            messageInput.current.textarea.value = '';
            messageInput.current.textarea.blur();

            onSubmit({ message: isNotEmptyValue });
        }
    };

    useEffect(() => {
        if (isMobile) {
            return;
        }

        window.addEventListener('keydown', handleKeyDown);

        return () => window.removeEventListener('keydown', handleKeyDown);
    }, [isMobile]);
};
